import * as Actions from 'reducks/storeTimesale/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const StoreTimesaleReducer = (state = initialState.storeTimesale, action: any) => {
  switch (action.type) {
    case Actions.FETCH_STORE_TIMESALE:
      return {
        storeTimesale: { ...action.payload },
      }
    case Actions.INIT_STORE_TIMESALE:
      return {
        storeTimesale: null,
      }
    default:
      return state
  }
}
